<template>
    <div class="flex gap-1">
        <div
            v-for="(attUuid, index) in attachments"
            :key="attUuid"
            class="hover:bg-primary/50 border-base-200 shadow rounded flex items-center px-0.5"
            :class="[
                attUuid === selectedDocumentMetaUuid ? 'bg-primary/50' : 'bg-primary/20',
                isHoverToOpenDocumentPreviewModal ? 'cursor-zoom-in' : 'cursor-pointer'
            ]"
            @click="onClickDocumentLink(attUuid)"
            @mouseover="onHoverDocumentLink(attUuid)"
        >
            <i class="i-ph-file-magnifying-glass text-xl"/><span class="truncate">{{ attachments.length > 1 ? (index + 1) : '' }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, provide, ref, watch} from 'vue'
import {getTransactionByUuid} from '@/transaction/transaction.service'
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'
import {TransactionInfo} from '@/pending-transaction/pendingTransaction.types'

const {onClickDocumentLink, onHoverDocumentLink, isHoverToOpenDocumentPreviewModal, selectedDocumentMetaUuid} = useDocumentPreviewModalService()
const props = defineProps({
    params: {
        type: Object as () => {
            value: TransactionInfo[],
            context: any
        },
        required: true
    }
})

provide('panelId', props.params?.context?.panelId)
provide('panelPathSegment', props.params?.context?.panelPathSegment)

const transactionUuids = computed(() => props.params.value.map(t => t.transactionUuid))

const attachments = ref<string[]>([])
watch(transactionUuids, async () => {
    if (transactionUuids.value) {
        transactionUuids.value.forEach(async (uuid: string) => {
            const transaction = await getTransactionByUuid(uuid)
            attachments.value.push(...(transaction?.documentMetaUuids || []))
        })
    }
}, {immediate: true})
</script>

<style scoped>

</style>